import type { SearchStep } from "@/lib/types";

const compactFormatter = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const scoreFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });
const dateFormatter = new Intl.DateTimeFormat("en-US", { dateStyle: "medium", timeStyle: "short" });

const stepLabels: Record<SearchStep, string> = {
  pending: "Preparing search",
  eligibility: "Checking query fit",
  suggest_repos: "Finding relevant repositories",
  validate_repos: "Validating suggested repositories",
  fetch_contributors: "Fetching contributors",
  score: "Scoring contributors",
  complete: "Finishing",
};

export function formatDateTime(value: string | null) {
  if (!value) {
    return "—";
  }

  return dateFormatter.format(new Date(value));
}

export function formatCompactNumber(value: number) {
  return compactFormatter.format(value);
}

export function formatScore(value: number) {
  return scoreFormatter.format(value);
}

export function getStepLabel(step: SearchStep | null) {
  return step ? stepLabels[step] : "Preparing search";
}
